var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as TYPES from "./types";
import * as publisherService from '../../services/publisher-service';
import * as reportService from '../../services/report-service';
import { multiAction } from '../../utils/ReduxUtil';
import * as LocalStorageUtil from '../../utils/LocalStorageUtil';
import _ from 'lodash';
export var publisherInit = function () { return ({ type: TYPES.GET_PUBLISHER_INIT }); };
export var publisherSuccess = function (data) { return ({ type: TYPES.GET_PUBLISHER_SUCCESS, data: data }); };
export var publisherError = function (error) { return ({ type: TYPES.GET_PUBLISHER_ERROR, error: error }); };
export var publisherDone = function () { return ({ type: TYPES.GET_PUBLISHER_DONE }); };
export var getPublisher = function (params) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, publishers, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(publisherInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, publisherService.getPublisher(params)];
                case 2:
                    result = _a.sent();
                    publishers = _.sortBy(result, "name");
                    publishers[0].selected = true;
                    LocalStorageUtil.storeItem(LocalStorageUtil.PUBLISHERS_KEY, JSON.stringify(publishers));
                    dispatch(multiAction([publisherSuccess(publishers), publisherDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    dispatch(multiAction([publisherError(err_1), publisherDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var publisherRevenueInit = function () { return ({ type: TYPES.GET_PUBLISHER_REVENUE_INIT }); };
export var publisherRevenueSuccess = function (data) { return ({ type: TYPES.GET_PUBLISHER_REVENUE_SUCCESS, data: data }); };
export var publisherRevenueError = function (error) { return ({ type: TYPES.GET_PUBLISHER_REVENUE_ERROR, error: error }); };
export var publisherRevenueDone = function () { return ({ type: TYPES.GET_PUBLISHER_REVENUE_DONE }); };
export var getPublisherRevenue = function (params) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(publisherRevenueInit());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, publisherService.getPublisherRevenue(params)];
                case 2:
                    result = _a.sent();
                    dispatch(multiAction([publisherRevenueSuccess(result), publisherRevenueDone()]));
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    dispatch(multiAction([publisherRevenueError(err_2), publisherRevenueDone()]));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var publisherDisplaySelected = function (publisherSelect) { return ({ type: TYPES.PUBLISHER_DISPLAY_LAYOUT, publisherSelect: publisherSelect }); };
export var publisherLayout = function (publisherSelect) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(publisherDisplaySelected(publisherSelect));
            return [2 /*return*/];
        });
    }); };
};
export var resetPublisherInfo = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(publisherSuccess(null));
            dispatch(publisherError(null));
            return [2 /*return*/];
        });
    }); };
};
export var storeReportPublishers = function (data) { return ({ type: TYPES.STORE_PUBLISHERS_REPORT_SUCCESS, data: data }); };
export var updateDefaultSettingInit = function () { return ({ type: TYPES.UPDATE_DEFAULT_SETTING_INIT }); };
export var updateDefaultSettingSuccess = function (data) { return ({ type: TYPES.UPDATE_DEFAULT_SETTING_SUCCESS, data: data }); };
export var updateDefaultSettingError = function (error) { return ({ type: TYPES.UPDATE_DEFAULT_SETTING_ERROR, error: error }); };
export var updateDefaultSettingStatus = function (status) { return ({ type: TYPES.UPDATE_DEFAULT_SETTING_STATUS, status: status }); };
export var updateDefaultSetting = function (defaultViewData) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(updateDefaultSettingStatus(false));
                    return [4 /*yield*/, reportService.updateDefaultSetting(defaultViewData)];
                case 1:
                    result = _a.sent();
                    // if (result && result.reportTabDefaultView) {
                    //   storeItem(REPORT_TAB_DEFAULT_VIEW, JSON.stringify(result.reportTabDefaultView));
                    // }
                    dispatch(updateDefaultSettingSuccess(result));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    dispatch(updateDefaultSettingError(error_1));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var resetDefaultViewStatus = function () {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(updateDefaultSettingStatus(false));
            return [2 /*return*/];
        });
    }); };
};
